<script>
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/svelte';
import {PLAYER_STATE} from "../chess-console-app/ChessConsoleAppState.js"
import {fade, slide, fly} from 'svelte/transition'
import {push, pop, replace, location} from 'svelte-spa-router'
import {Lottie} from 'lottie-svelte';
import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
import { launchSumsub } from '../sumsub.js';
import OtpInput from 'svelte-otp'
import LocalStorage from '../localstorage.js'
import {getUserData} from '../userdata.js'

import {Motion, M} from 'svelte-motion'
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import Tailwindcss from '../Tailwind.svelte'
import {animateScroll} from 'svelte-scrollto-element'
import { registerUser } from '../auth';
import {getCountries}  from '../userdata'
import {auth} from '../firebase.js'
import {sessionData} from '../stores'
import {_} from 'svelte-i18n'
import { onMount } from 'svelte'
import {container, itemA, apayment, itemB, itemC, itemM} from './animations.js'
import TelInput, { normalizedCountries } from 'svelte-tel-input';

//$: locationLabel = ($location.substr(1).toLowerCase()).split('/')[0]
$: locationLabel = $location == "/wallet" ? $_('common.wallet') : ($location == "/Play" ? $_('gameplay.play') : "")
$: balance = $sessionData.guser.current_balance

let trigger = false
let hideBalance = false
let ln = new LocalStorage("notification_")


function addNotice() {
    ln.push({title: "challenge", description: "oskar challenged you to a blitz game"})
}

function addZeroes(str) {
    var num = String(str)
    var value = Number(num);
    var res = num.split(".");
    if(res.length == 1 || res[1].length < 3) {
        value = value.toFixed(2);
    }
return String(value);
}

function hideBalanceFunc(){
  hideBalance = !hideBalance
}


function sout(){
   auth.signOut()
    replace("/Login")
    window.location.reload()
}

function showSumsub(){
  if($sessionData.guser?.kyc_status == 'completed') {
    return;
  } else if ($sessionData.sumsubApplication?.reviewStatus == 'pending') {
      $sessionData.sumsubHidden = false

  } else {

    $sessionData.sumsubHidden = true
    $sessionData.sumsubContinue = true

  }



}


function displaySumsub(){
    $sessionData.sumsubHidden = !$sessionData.sumsubHidden
    if(!$sessionData.sumsubApplication?.attemptId){
      setTimeout(() => {
          launchSumsub()
      }, 300);
    }

  }


async function getLocationData(lat, lon) {
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`);
    const data = await response.json();

    const locationData = {
        city: data.address.city || data.address.town || data.address.village || 'N/A',
        state: data.address.state || 'N/A',
        country: data.address.country || 'N/A',
    };

    return locationData;
}



  onMount(async() => {
      setTimeout(() => {
          trigger = true
      }, 400)

      setTimeout(() => {
          trigger = true
      }, 1000)
    })

</script>



{#if trigger && $sessionData.playerState == PLAYER_STATE.idle}
  <div out:fly={{y:20}}>
<M.div initial="hidden" variants={container} animate="show" class="pr-5 gap-x-10 z-50 top-0 flex flex-row items-center select-none bg-yellow w-screen xl:h-24 md:h-5 fixed">
  <M.img class="cursor-pointer" onTap={() => push('/Play')} variants={itemC} src="glogo.png"/>
  {#key locationLabel}
  <M.h1 variants={itemC} class="w-24 font-brown align-middle"> {locationLabel} </M.h1>
    {/key}

    {#if balance != null}
    <M.div title="tap to hide balance" variants={itemC}  class="flex gap-x-5 flex-row">
      {#key $sessionData.recent_payment}
      <M.div onTap={hideBalanceFunc} variants={$sessionData.recent_payment ? apayment : itemC}  class="ml-20 w-24 flex flex-col">
      <M.h1 class="text-xl font-brown">{$_('gameplay.balance')}</M.h1>
        {#if !hideBalance}
        <M.div class="flex flex-row" variants={itemC}>
      <M.h1 class="text-xl text-slate-400  font-autoscape">${addZeroes($sessionData.guser.current_balance,4)}</M.h1>
        </M.div>
        {:else}
        <M.div class="flex flex-row" variants={itemC}>
      <M.h1 class="text-xl text-slate-400 font-autoscape">{$_('common.hidden')}</M.h1>
        </M.div>
        {/if}
    </M.div>

      {/key}
    <M.img onTap={() => {push('/wallet')}} class="cursor-pointer" src="topup.svg"/>
    </M.div>
    {/if}

    {#if $sessionData.guser?.kyc_status != 'completed' && $sessionData.guser?.kyc_status != 'rejected' && $sessionData.sumsubApplication?.reviewStatus != 'pending'}
      <M.div class="flex gap-x-2 flex-row" variants={itemC}>
        <img on:click={showSumsub} class="w-12 cursor-pointer" src="passport.svg" alt="passport.svg">
        <div on:click={showSumsub} class="self-center cursor-pointer text-white leading-5 text-2xl font-brown" on:click={launchSumsub} variants={itemC}>{$_('common.verify')}<br> {$_('common.account')}</div>

      </M.div>
    {:else if $sessionData.sumsubApplication?.reviewStatus == 'pending'}
      <M.div class="flex gap-x-2 flex-row" variants={itemC}>
        <img class="w-12 cursor-pointer" src="passport.svg" alt="passport.svg">
        <div on:click={showSumsub} class="animate-pulse self-center cursor-pointer whitespace-pre-line text-white leading-5 text-xl font-brown" on:click={launchSumsub} variants={itemC}>{$_('identity.beingVerified')}</div>

        <div class="w-24">
      <Lottie loop={true} class="w-8" path="verify2.json" speed={1}/>
        </div>
      </M.div>
      {:else if $sessionData.guser?.kyc_status == 'completed' || $sessionData.sumsubApplication?.reviewResult?.reviewAnswer == 'GREEN'}

      <M.div class="flex gap-x-2 flex-row" variants={itemC}>


        <div on:click={showSumsub} class="self-center cursor-pointer whitespace-pre-line text-white leading-5 text-3xl font-brown" variants={itemC}>{$_('identity.verified')}</div>

        <div class="-translate-y-4 -translate-x-3 w-12">
      <Lottie loop={false} class="w-8" path="sumsub-verified.json" speed={1}/>
        </div>

      </M.div>
      {:else if $sessionData.sumsubApplication?.reviewResult?.reviewAnswer == 'RED' || $sessionData.guser.kyc_status == 'rejected'}


      <M.div class="flex gap-x-2 flex-row" variants={itemC}>


        <div on:click={showSumsub} class="self-center cursor-pointer text-white whitespace-pre-line leading-5 text-2xl font-brown" variants={itemC}>{$_('identity.failed')}</div>

        <div class="w-24">
      <Lottie loop={false} class="w-8" path="nfc-fail.json" speed={0.6}/>
        </div>

      </M.div>


      {/if}

        {#if $sessionData.payment_failed}
          <M.div  class="gap-x-4 content-center flex flex-row" variants={itemM}>
        <div out:fly={{y: 20, opacity: 0, duration: 500}} class="w-12">
      <Lottie loop={false} class="w-8" path="declined.json" speed={0.6}/>
        </div>

        <div out:fly={{y: 20, opacity: 0, duration: 500}} on:click={() => push('/wallet')} class="self-center text-lerror whitespace-pre-line cursor-pointer leading-6 text-2xl font-brown" variants={itemC}>{$_('payment.failed')}</div>
        </M.div>
        {:else if $sessionData.recent_payment}


          <M.div class="gap-x-4 content-center flex flex-row" variants={itemC}>
        <div out:fly={{y: 20, opacity: 0, duration: 500}} class="w-16">
      <Lottie loop={false} class="w-8" path="accepted.json" speed={0.6}/>
        </div>

        <div out:fly={{y: 20, opacity: 0, duration: 500}} on:click={() => push('/wallet')} class="self-center text-gmint cursor-pointer leading-6 text-2xl font-brown" variants={itemC}>{$_('payment.toppedUp')}</div>
        </M.div>

        {/if}


        {#if $sessionData.recent_victory}
          <M.div  class="gap-x-4 content-center flex flex-row" variants={itemM}>
        <div out:fly={{y: 20, opacity: 0, duration: 500}} class="w-16">
      <Lottie loop={false} class="w-8" path="winning.json" speed={1.2}/>
        </div>

        <div out:fly={{y: 20, opacity: 0, duration: 500}} on:click={() => push('/wallet')} class="self-center text-gambit cursor-pointer  text-5xl font-brown" variants={itemC}>{$_("common.victory")}</div>
        </M.div>
        {:else if $sessionData.recent_defeat}


          <M.div class="gap-x-4 content-center flex flex-row" variants={itemC}>
        <div out:fly={{y: 20, opacity: 0, duration: 500}} class="w-16">
      <Lottie loop={false} class="w-8" path="accepted.json" speed={0.6}/>
        </div>

        <div out:fly={{y: 20, opacity: 0, duration: 500}} on:click={() => push('/wallet')} class="self-center text-gmint whitespace-pre-line cursor-pointer leading-6 text-2xl font-brown" variants={itemC}>{$_('payment.successful')}</div>
        </M.div>

        {/if}

    <M.div class="ml-auto flex flex-row">



    </M.div>
</M.div>
</div>
{/if}


<style>
</style>
